import { IAppRoute } from 'interfaces/route';
import React from 'react';

import EntityRouter from './entityRouter';

export default class CategoryRouter extends React.PureComponent {
  // dynamically linked
  public static routes: IAppRoute[] = [{
    path: '/null',
    sideDrawer: { display: 'Carregando...' },
    component: EntityRouter,
    exact: false,
  }];

  render() {
    return (this.props.children);
  }
}
